import { render } from "./BaseButtonLink.vue?vue&type=template&id=6849d5fa&scoped=true"
import script from "./BaseButtonLink.vue?vue&type=script&lang=js"
export * from "./BaseButtonLink.vue?vue&type=script&lang=js"

import "./BaseButtonLink.vue?vue&type=style&index=0&id=6849d5fa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6849d5fa"

export default script